import { jsxs, jsx, Fragment } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import React__default, { memo } from "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { LockViewfinderOutlined as H } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/lock-viewfinder-outlined.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import Grid from "../../../../node_modules/@mui/material/Grid/Grid.es.js";
import { getIconColor } from "../utils/product-card.functions.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { Typography } from "../../typography/typography.es.js";
function ProductCardTitleGenerator({
  isLocked,
  disabled,
  accentColor,
  title,
  isMobile,
  titleIcon
}) {
  var _a;
  const iconColor = getIconColor(accentColor, disabled);
  const titleVariant = isMobile ? "subtitle1" : "h6";
  const itemsAlignment = isMobile ? Alignment.start : Alignment.center;
  let renderedTitleIcon = titleIcon;
  if (titleIcon && !((_a = titleIcon == null ? void 0 : titleIcon.props) == null ? void 0 : _a.color)) {
    renderedTitleIcon = React__default.cloneElement(titleIcon, {
      color: iconColor,
      ...titleIcon == null ? void 0 : titleIcon.props
    });
  }
  return /* @__PURE__ */ jsxs(Grid, { item: true, xs: 12, zeroMinWidth: true, display: Displaying.flex, gap: Spacing["500"], alignItems: itemsAlignment, children: [
    isLocked ? /* @__PURE__ */ jsx(H, { color: iconColor }) : /* @__PURE__ */ jsx(Fragment, {}),
    renderedTitleIcon || /* @__PURE__ */ jsx(Fragment, {}),
    /* @__PURE__ */ jsx(Typography, { variant: titleVariant, color: "textPrimary", "data-testid": "product-card-title", children: title })
  ] });
}
const ProductCardTitle = memo(ProductCardTitleGenerator);
export {
  ProductCardTitle
};
//# sourceMappingURL=product-card-title.es.js.map
